import { Flex, PartnerLogo, Typography } from '@iheartjane/reefer';

import { useCheckout } from '@jane/shared-ecomm/providers';

export const CheckoutStoreCard = () => {
  const { store } = useCheckout();

  return (
    <Flex alignItems="center">
      <PartnerLogo name={store.name} variant="store" image={store.photo} />
      <Flex flexDirection="column" ml={16} justifyContent="center">
        <Typography variant="body-semibold">{store.name}</Typography>
        <Typography>{store.address}</Typography>
        <Typography>{`${store.city}, ${store.state} ${store.zip}`}</Typography>
      </Flex>
    </Flex>
  );
};
